import { FormattedMessage, FormattedTime } from 'react-intl';
import { defineMessages, useIntl } from 'react-intl';
import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { expandToBackendURL } from '@plone/volto/helpers/Url/Url';
import { Container } from '@plone/components';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import time from '../../../icons/time.svg';
import calendar from '../../../icons/calendar.svg';
import location from '../../../icons/location.svg';
import user from '../../../icons/user.svg';
import event_add from '../../../icons/event_add.svg';
import globe from '@plone/volto/icons/globe.svg';

const messages = defineMessages({
  fromto: {
    id: 'fromto',
    defaultMessage: 'from {start} to {end}',
  },
  startingat: {
    id: 'startingat',
    defaultMessage: 'starting at {start}',
  },
});

const EventMetadataView = (props) => {
  const intl = useIntl();
  const content = props.properties;
  const isWholeDay = !!content.whole_day;
  const isOpenEnd = !content.end || !!content.open_end;
  const isSameDay =
    content.start &&
    content.end &&
    new Date(content.start).toDateString() ===
      new Date(content.end).toDateString();
  const dateOptions =
    isWholeDay || isSameDay
      ? {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }
      : {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        };

  return (
    <div className="block eventMetadata ">
      <Container className="details-container">
        <div className="content-container">
          {isSameDay ? (
            <>
              <div className="event-info date">
                <span className="event-heading">
                  <Icon
                    name={calendar}
                    size="20px"
                    title={intl.formatMessage({
                      id: 'Date',
                      defaultMessage: 'Date',
                    })}
                  />
                </span>
                <div className="event-detail">
                  {' '}
                  {content?.start && (
                    <FormattedDate
                      date={content.start}
                      format={{
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        weekday: 'long',
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="event-info time">
                <span className="event-heading">
                  <Icon
                    name={time}
                    size="20px"
                    title={intl.formatMessage({
                      id: 'Time',
                      defaultMessage: 'Time',
                    })}
                  />
                </span>
                <div className="event-detail">
                  {content?.end && !isOpenEnd && !isWholeDay ? (
                    <>
                      {intl.formatMessage(messages.fromto, {
                        start: intl.formatTime(content.start, {
                          hour: 'numeric',
                          minute: 'numeric',
                        }),
                        end: intl.formatTime(content.end, {
                          hour: 'numeric',
                          minute: 'numeric',
                        }),
                      })}
                    </>
                  ) : (
                    <>
                      {intl.formatMessage(messages.startingat, {
                        start: intl.formatTime(content.start, {
                          hour: 'numeric',
                          minute: 'numeric',
                        }),
                      })}
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="event-info">
                <span className="event-heading">
                  <Icon
                    name={calendar}
                    size="20px"
                    title={intl.formatMessage({
                      id: 'Start',
                      defaultMessage: 'Start',
                    })}
                  />
                </span>
                <div className="event-detail">
                  {' '}
                  {content?.start && (
                    <FormattedDate date={content.start} format={dateOptions} />
                  )}
                </div>
                <div className="separator"></div>
              </div>
              {!isOpenEnd ? (
                <div className="event-info">
                  <span className="event-heading">
                    <Icon
                      name={calendar}
                      size="20px"
                      title={intl.formatMessage({
                        id: 'End',
                        defaultMessage: 'End',
                      })}
                    />
                  </span>
                  <div className="event-detail">
                    {' '}
                    {content?.end && (
                      <FormattedDate date={content.end} format={dateOptions} />
                    )}
                  </div>
                  <div className="separator"></div>
                </div>
              ) : null}
            </>
          )}
          {content?.location && (
            <div className="event-info">
              <span className="event-heading">
                <Icon
                  name={location}
                  size="24px"
                  title={intl.formatMessage({
                    id: 'Location',
                    defaultMessage: 'Location',
                  })}
                />
              </span>
              <div className="event-detail">{content?.location}</div>
            </div>
          )}

          {content?.event_url && (
            <div className="event-info">
              <span className="event-heading">
                <Icon
                  name={globe}
                  size="20px"
                  title={intl.formatMessage({
                    id: 'Website',
                    defaultMessage: 'Website',
                  })}
                />
              </span>
              <div className="event-detail">
                <UniversalLink className="event-url" href={content.event_url}>
                  <FormattedMessage
                    id="Event website"
                    defaultMessage="Event website"
                  />
                </UniversalLink>
              </div>
              <div className="separator"></div>
            </div>
          )}

          {(content?.contact_name ||
            content?.contact_email ||
            content?.contact_email) && (
            <div className="event-info">
              <span className="event-heading">
                <Icon
                  name={user}
                  size="20px"
                  title={intl.formatMessage({
                    id: 'Contact',
                    defaultMessage: 'Contact',
                  })}
                />
              </span>
              <div className="event-detail">
                <div>
                  {content?.contact_name && <p>{content.contact_name}</p>}
                  {content?.contact_email && (
                    <p>
                      <a href={`mailto:${content.contact_email}`}>
                        {content.contact_email}
                      </a>
                    </p>
                  )}
                  {content?.contact_phone && (
                    <p>
                      <FormattedMessage id="Phone" defaultMessage="Phone" />{' '}
                      <a href={`tel:${content.contact_phone}`}>
                        {content.contact_phone}
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="event-ics">
          <a
            className="ics-download no-icon"
            target="_blank"
            rel="noreferrer"
            href={
              content && content['@id']
                ? `${expandToBackendURL(content['@id'])}/ics_view `
                : ''
            }
          >
            <FormattedMessage
              id="download_event_metatdata"
              defaultMessage="Download ICS"
            />
            <Icon
              name={event_add}
              size="20px"
              title={intl.formatMessage({
                id: 'ICS Download',
                defaultMessage: 'ICS Download',
              })}
            />
          </a>
        </div>
      </Container>
    </div>
  );
};

export default EventMetadataView;
